import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';
import type { OverviewCategory } from 'shared/src/api';

export const useLogClickHeadlineMore = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    (category: OverviewCategory) => {
      logAnalyticsEvent({
        name: 'CLICK_HEADLINE_SMALL_ONE_LINE_MORE',
        analytics: { ...category.logging.analytics },
      });
    },
    [logAnalyticsEvent],
  );
};
